export const INTEGRATIONS_MAX_FORM_LIMIT = {
  title: 128,
  callbackUrl: 256,
};
